import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './CountriesList.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;


const CountriesList = () => {
  const [country, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${url}/api/country`);
        setCountries(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch countries');
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${url}/api/country/${id}`);
      setCountries(country.filter(country => country._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete country');
    }
  };

  if (loading) return <div className="loading">Loading countries...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="countries-container">
      <div className="header">
        <h2>Countries List</h2>
        <button 
          onClick={() => navigate('/AddCountry')}
          className="add-button"
        >
          <Plus size={16} /> Add Country
        </button>
      </div>

      <table className="countries-table">
        <thead>
          <tr>
            <th>Name</th>
            
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {country.map(country => (
            <tr key={country._id}>
              <td>{country.name}</td>
             
              <td className="actions">
                <button 
                  onClick={() => navigate(`/Country/edit/${country._id}`)}
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>
                {/* <button 
                  onClick={() => handleDelete(country._id)}
                  className="delete-btn"
                >
                  <Trash2 size={14} />
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CountriesList;